// Panel

import Administracion from './Administracion'
import Dashboard from './Dashboard'
import ConfigurarDemo from './ConfigurarDemo'
import ListarAspectosGlobales from './aspectos/Listado'
import CrearAspectosGlobales from './aspectos/Crear'
import EditarAspectosGlobales from './aspectos/Editar'
import OrganizacionesListado from './organizaciones/Listado'
import OrganizacionCrear from './organizaciones/Crear'

const BASE_PATH = '/admin'

const routes = [
  {
    path: BASE_PATH,
    component: Administracion,
    meta: {
      requiresAuth: true,
      requiredRoles: ['lyris']
    },
    children: [
      {
        path: '',
        component: Dashboard,
        name: 'adminDashboard'
      },
      {
        path: 'organizaciones',
        component: OrganizacionesListado,
        name: 'adminOrganizacionesListado'
      },
      {
        path: 'crear-organizacion',
        component: OrganizacionCrear,
        name: 'adminOrganizacionCrear'
      },
      {
        path: 'configurar-demo',
        component: ConfigurarDemo,
        name: 'lyrisConfigurarDemo'
      },
      {
        path: 'aspectos-globales',
        component: ListarAspectosGlobales,
        name: 'adminAspectosGlobalesListado'
      },
      {
        path: 'aspectos-globales/crear',
        component: CrearAspectosGlobales,
        name: 'adminAspectosGlobalesCrear'
      },
      {
        path: 'aspectos-globales/:idAspecto/editar',
        component: EditarAspectosGlobales,
        name: 'adminAspectosGlobalesEditar',
        props: true
      }
    ]
  }
]
export default routes
